import {browserHistory} from 'react-router';
import Raven from 'raven-js';
import store from 'store';

import {SubmissionError} from 'redux-form';

import PolyUtil from '../../../util/PolyUtil';
import {clearUser, fetchUser} from '../../../store/actions/user';
import {handleAddToInterestList} from "../../tenant/actions/tenant";
// import {setNavbarVisibility, setFooterVisibility} from '../../navigation/actions/navbar';
import {fetchOwner, handleClaimProperty} from "../../owner/actions/owner";

// thunk which dispatches actions and calls external libraries to end user session
export const logoutUser = (user) => dispatch => {
    dispatch(clearUser());
    Raven.setUserContext(); // clear Sentry context
    window.Intercom('shutdown');
    window.FS.identify(false);
    store.remove('access_token');
    store.remove('type');
    browserHistory.push('/login');
};

export const loginUser = (user) => dispatch => {
    return PolyUtil.fetchWrapper('/api/login/', {
        method: 'POST',
        body: JSON.stringify(user)
    }).then((data) => {
        store.set('access_token', 'Token ' + data.token);
        store.set('type', data.user_type);
        browserHistory.push('/dashboard/');
        return dispatch(fetchUser());
    }).catch(error => {
        console.log('Error:', error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        if (error.detail === 'Invalid token.') { // logout if token invalid
            dispatch(logoutUser());
        }
        throw new SubmissionError(error);
    });
};

export const registerOwner = (owner, prop_id) => dispatch => {
    store.set('prop_id', prop_id);
    return PolyUtil.fetchWrapper('/api/landlord/register/',
        {
            method: 'POST',
            body: JSON.stringify(PolyUtil.prepData(owner))
        }
    ).then(() => {
        return dispatch(loginUser({
            username: owner.email,
            password: owner.password
        }));
    }).then(() => {
        return dispatch(handleClaimProperty(prop_id));
    }).then(() => {
        browserHistory.push('/dashboard/');
        return dispatch(fetchOwner());
    }).catch(error => {
        console.log('Error:', error);
        error.email && (error._error = error.email);
        throw new SubmissionError(error);
    });

};

export const registerTenant = (user) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/register/', {
        method: 'POST',
        body: JSON.stringify({
            email: user.username,
            password: user.password,
            first_name: user.first_name,
            last_name: user.last_name
        })
    })
};


export const registerUser = (user) => dispatch => {
    return dispatch(registerTenant(user)).then(() => {
        return PolyUtil.fetchWrapper('/api/login/', {
            method: 'POST',
            body: JSON.stringify({
                username: user.username,
                password: user.password
            })
        });
    }).then((data) => {
        store.set('access_token', 'Token ' + data.token);
        store.set('type', data.user_type);
    }).then(() => {
        if (store.get('prop_id')) {
            const id = store.get('prop_id');
            store.remove('prop_id');
            return dispatch(handleAddToInterestList({id: id}));
        }
    }).then(() => {
        return store.get('type') === 'tenant' && PolyUtil.fetchWrapper(
            '/api/tenant/rome/',
            {
                method: 'POST',
                body: JSON.stringify({
                    rome_decision: 'coordinate_group'
                })
            }
        );
    }).then(() => {
        return dispatch(fetchUser());
    }).then(() => {
        if (!!store.get('listing')) {
            browserHistory.push('/listings/' + store.get('listing'));
        } else {
            browserHistory.push('/dashboard/');
        }

    }).catch(error => {
        console.log('error', error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }

        if (error.detail === 'Invalid token.') { // logout if token invalid
            dispatch(logoutUser());
        }

        if (error.email) {
            throw new SubmissionError({
                _error: error.email
            });
        }

    });
};



// WEBPACK FOOTER //
// ./src/containers/authentication/actions/authentication.js